import React from 'react';

const StatsGrid = () => {
  const stats = [
    {
      title: 'إجمالي الأخبار',
      value: '10',
      iconClass: 'blue',
      icon: (
        <svg className="icon" viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14,2 14,8 20,8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
      )
    },
    {
      title: 'الأخبار المنشورة',
      value: '7',
      iconClass: 'green',
      icon: (
        <svg className="icon" viewBox="0 0 24 24">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
          <circle cx="12" cy="12" r="3"/>
        </svg>
      )
    },
    {
      title: 'المسودات',
      value: '3',
      iconClass: 'orange',
      icon: (
        <svg className="icon" viewBox="0 0 24 24">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
      )
    },
    {
      title: 'إجمالي المشاهدات',
      value: '6,152',
      iconClass: 'purple',
      icon: (
        <svg className="icon" viewBox="0 0 24 24">
          <polyline points="22,12 18,12 15,21 9,3 6,12 2,12"/>
        </svg>
      )
    }
  ];

  return (
    <div className="stats-grid">
      {stats.map((stat, index) => (
        <div key={index} className="stat-card">
          <div className="stat-info">
            <p>{stat.title}</p>
            <h3>{stat.value}</h3>
          </div>
          <div className={`stat-icon ${stat.iconClass}`}>
            {stat.icon}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsGrid;